import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { isBoolean } from 'lodash';
import { getEpikBoxesBySerialNumber } from '../../actions/EpikBoxes';
import * as BoxesActions from '../../actions/EpikBoxes';
import TableRowData from './TableRowData';
import SpinnerCircles from '../Spinner/SpinerCircles';
import axios from 'axios';

export default function FulfillmentData({
  isAllSelected,
  item,
  setInputFocus,
  setSelectedRow,
  selectedRow,
  checklastRow,
  setChecklastRow,
}) {
  const token = localStorage.getItem('jwtToken') || null;
  const dispatch = useDispatch();
  const [box, setBox] = useState(null);
  const [checkbox, setCheckBox] = useState(isAllSelected);
  const [serialNumber, setSerialNumber] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [location, setLocation] = useState('');
  const [powerCycle, setPowerCycle] = useState(null);
  const [firmwareUpdate, setFirmwareUpdate] = useState(null);
  const [simStatus, setSimStatus] = useState({
    sim1Status: null,
    sim2Status: null,
  });
  const [simCarrier, setSimCarrier] = useState({
    sim1Carrier: null,
    sim2Carrier: null,
  });
  const [systemStatus, setSystemStatus] = useState(null);
  const [pingSim, setPingSim] = useState({
    pingSim1: null,
    pingSim2: null,
  });

  const handleSim = async boxes => {
    const simValue = await dispatch(BoxesActions.showUpdateEpikBox(boxes?.docs?.[0]));
    const modemSim = simValue?.modems?.length ? simValue?.modems?.[0]?.sims : null;
    if (modemSim) {
      if (modemSim?.length === 1) {
        modemSim.push('');
      }
      const body = {
        keys: modemSim,
      };
      const sim = await dispatch(BoxesActions.getSimStatus(token, body));
      if (sim) {
        const sim1 = sim?.[0];
        const sim2 = sim?.[1];

        let sim1Value = null;
        let sim2Value = null;
        let pingSim1 = null;
        let pingSim2 = null;

        if (sim1?.status === 'Not Activated') {
          sim1Value = false;
        }
        if (sim1?.status === 'Activated') {
          sim1Value = true;
        }

        if (sim2?.status === 'Not Activated') {
          sim2Value = false;
        }
        if (sim2?.status === 'Activated') {
          sim2Value = true;
        }

        setSimStatus({ sim1Status: sim1Value, sim2Status: sim2Value });
        setSimCarrier({
          sim1Carrier: isBoolean(sim1Value),
          sim2Carrier: isBoolean(sim2Value),
        });
        if (sim1?.ip) {
          pingSim1 = await dispatch(BoxesActions.pingSim(token, sim1?.ip));
        }

        if (sim2?.ip) {
          pingSim2 = await dispatch(BoxesActions.pingSim(token, sim2?.ip));
        }

        setPingSim({ pingSim1, pingSim2 });
      }
    }
  };

  const handlePowerCycle = async boxes => {
    const { CancelToken } = axios;
    const source = CancelToken.source();
    setTimeout(() => {
      source.cancel('Operation canceled by the user.');
    }, 3000);
    const value = await dispatch(
      BoxesActions.boxHardReset(token, boxes?.docs[0]?.vpnAddress, source),
    );
    setPowerCycle(value);
  };

  const serialSearchFilter = async () => {
    if (serialNumber.length >= 10) {
      setIsLoading(true);
      const boxes = await dispatch(getEpikBoxesBySerialNumber(token, serialNumber));
      boxes?.docs?.[0]?.myEpik ? (global.myEpik = 'Yes') : (global.myEpik = 'No');
      setBox(boxes?.docs?.[0]?.status);
      if (boxes?.docs?.length) {
        const boxId = boxes?.docs?.[0]?._id;
        let systemValue = await dispatch(BoxesActions.getSystemStatus(token, boxId));
        systemValue = systemValue
          ?.filter(
            items =>
              items?.placeHolderText === 'Registered' ||
              items?.placeHolderText === 'Register Config Created',
          )
          ?.map(items => items?.value);
        if (systemValue?.[0] === 'true' && systemValue?.[1] === 'true') {
          systemValue = true;
        } else if (systemValue?.[0] === 'false' && systemValue?.[1] === 'false') {
          systemValue = false;
        } else {
          systemValue = null;
        }
        setSystemStatus(systemValue);
        const data = await dispatch(BoxesActions.applyUpdateEpikBox(token, boxes?.docs?.[0]?._id));
        setFirmwareUpdate(data);
        await handleSim(boxes);
        await handlePowerCycle(boxes);
      }
      setIsLoading(false);
    }
  };

  const handleCheckbox = e => {
    if (e.target.checked) {
      setSelectedRow([...selectedRow, item?.id]);
    } else {
      const newSection = selectedRow.filter(items => items !== item?.id);
      setSelectedRow(newSection);
    }
    setCheckBox(e.target.checked);
  };

  const clearAllInputs = () => {
    if (checklastRow) {
      setSerialNumber('');
      setCheckBox(false);
      setSimStatus({
        sim1Status: null,
        sim2Status: null,
      });
      setSimCarrier({
        sim1Carrier: null,
        sim2Carrier: null,
      });
      setPingSim({
        pingSim1: null,
        pingSim2: null,
      });
      setSystemStatus(null);
      setLocation('');
      setBox(null);
      setChecklastRow(false);
      setPowerCycle(null);
      setFirmwareUpdate(null);
    }
  };

  useEffect(() => {
    clearAllInputs();
  }, [checklastRow]);

  useEffect(() => setCheckBox(isAllSelected), [isAllSelected]);

  const handleInput = e => {
    setSerialNumber(e.target.value);
    setSystemStatus(null);
    setBox(null);
    setChecklastRow(false);
    setPowerCycle(null);
    setFirmwareUpdate(null);
    setSimStatus({
      sim1Status: null,
      sim2Status: null,
    });
    setSimCarrier({
      sim1Carrier: null,
      sim2Carrier: null,
    });
    setPingSim({
      pingSim1: null,
      pingSim2: null,
    });
  };

  return (
    <tr className="full-filltable-row" style={{ position: 'relative' }}>
      <>
        <TableRowData>
          <input type="checkbox" checked={checkbox} onChange={e => handleCheckbox(e)} />
        </TableRowData>
        <TableRowData>
          <Input
            type="text"
            name="location"
            value={location}
            onChange={e => setLocation(e.target.value)}
            onFocus={() => setInputFocus(true)}
            onBlur={() => setInputFocus(false)}
          />
        </TableRowData>
        <TableRowData>
          <InputGroup>
            <Input
              style={{ margin: '0px' }}
              type="text"
              name="serialNumber"
              placeholder="Serial Number"
              value={serialNumber}
              onChange={e => handleInput(e)}
              disabled={isLoading}
              onFocus={() => setInputFocus(true)}
              onBlur={() => setInputFocus(false)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  serialSearchFilter();
                }
              }}
            />
            <InputGroupAddon addonType="append">
              <Button
                disabled={serialNumber?.length < 10}
                color="primary"
                onClick={serialSearchFilter}
              >
                Execute
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </TableRowData>
        <TableRowData status={box} />
        <TableRowData status={systemStatus} />
        <TableRowData status={firmwareUpdate} />
        <TableRowData status={simStatus?.sim1Status} />
        <TableRowData status={simCarrier?.sim1Carrier} />
        <TableRowData status={pingSim?.pingSim1} />
        <TableRowData status={simStatus?.sim2Status} />
        <TableRowData status={simCarrier?.sim2Carrier} />
        <TableRowData status={pingSim?.pingSim2} />
        <TableRowData status={powerCycle} />
      </>
      {isLoading && (
        <div
          className="d-flex flex-column justify-content-center align-items-center"
          style={{
            background: 'rgba(19, 18, 18, 0.2)',
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
          }}
        >
          <SpinnerCircles red />
        </div>
      )}
    </tr>
  );
}
